import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { ICreateEngateBody } from 'src/app/services/EngateDesengateService/engateDesengate.model';
import { EngateDesengateService } from 'src/app/services/EngateDesengateService/engateDesengate.service';
import { ModalSelecaoDesengateComponent } from '../modal-selecao-desengate/modal-selecao-desengate.component';
import { ActivatedRoute, Router } from '@angular/router';
import { generateUUID } from 'src/app/core/generators/generateUUID';
import { EntradaGateService } from 'src/app/services/EntradaGateService/entradaGate.service';
import { CaminhaoService } from 'src/app/services/CaminhaoService/caminhao.service';
import { SwalAlertService } from 'src/app/services/SwalAlertService/swalAlert.service';
import { ModalAutorizacaoComponent } from '../modal-autorizacao/modal-autorizacao.component';
import {
  tratarIsNullOrEmpty,
  tratarIsNullOrEmptyString,
  validarCPF,
  validarIsNullOrEmpty
} from 'src/app/core/utils/utilities';

@Component({
  selector: 'app-cadastro-engate',
  templateUrl: './cadastro-engate.component.html',
  styleUrls: ['./cadastro-engate.component.scss']
})
export class CadastroEngateComponent implements OnInit {
  form: FormGroup;
  idFuncionario = Number(localStorage.getItem('id'));
  guid: string = generateUUID();
  permissionToken: string = '';
  isEditing: boolean = false;
  isViewing: boolean = false;
  isLoading: boolean = false;
  isEntradaValida: boolean = false;

  constructor(
    private fb: FormBuilder,
    private router: Router,
    private route: ActivatedRoute,
    private engateDesengateService: EngateDesengateService,
    public dialog: MatDialog,
    public entradaGateService: EntradaGateService,
    public caminhaoService: CaminhaoService,
    public swalAlert: SwalAlertService
  ) {
    this.form = this.initForm();
  }

  ngOnInit(): void {
    this.activateRoute();
  }

  initForm(): FormGroup {
    const form = this.fb.group({
      FK_AGND: [null],
      TX_PLCA_DSGT: [null],
      NM_MTRT_DSGT: [null, Validators.required],
      NM_MTRT: [null, Validators.required],
      TX_CPF: [
        null,
        [Validators.required, Validators.pattern(/^\d{11}$/), validarCPF]
      ],
      TX_TELE: [null],
      TX_PLCA_CAVA: [null, Validators.required],
      FK_CRRT_1: [null, Validators.required],
      FK_CRRT_2: [null],
      FK_CRRT_3: [null],
      TX_PLCA_CRRT1: [null],
      TX_PLCA_CRRT2: [null],
      TX_PLCA_CRRT3: [null],
      FK_DSGT_ENGT: [null, Validators.required],
      FK_GATE_ENTR: [null],
      FK_CMNH: [null],
      TX_OBSV_ENGT_DSGT: [null, Validators.required],
      CRRT_DSGT: [null],
      TX_MAIL: [null, Validators.email],
      FL_MTRT_EMPR: [false]
    });
    return form;
  }

  saveEngate(): void {
    if (!this.isEditing) {
      this.postEngate();
    }
    if (this.isEditing) {
    }
  }

  postEngate(): void {
    this.isLoading = true;
    const payload = this.createPayload();
    this.engateDesengateService.CreateEngate(payload, this.guid).subscribe({
      next: res => {
        this.router.navigate(['listagem/engates']);
        this.isLoading = false;
      },
      error: err => {
        this.isLoading = false;
      }
    });
  }

  createPayload(): ICreateEngateBody | any {
    const idGateEntrada: number = Number(
      this.form.controls['FK_GATE_ENTR']?.value
    );
    const idAgendamento: number = Number(this.form.controls['FK_AGND']?.value);
    const placaCarreta1: String = this.form.controls['TX_PLCA_CRRT1']?.value;
    const placaCarreta2: String = this.form.controls['TX_PLCA_CRRT2']?.value;
    const placaCarreta3: String = this.form.controls['TX_PLCA_CRRT3']?.value;

    return {
      FK_FUNC_OPER: Number(this.idFuncionario),
      FK_GATE_ENTR: tratarIsNullOrEmpty(idGateEntrada),
      FK_DSGT_ENGT: Number(this.form.controls['FK_DSGT_ENGT']?.value),
      FK_AGND: tratarIsNullOrEmpty(idAgendamento),
      TX_OBSV_ENGT_DSGT: this.form.controls['TX_OBSV_ENGT_DSGT']?.value,
      NM_MTRT: tratarIsNullOrEmpty(this.form.controls['NM_MTRT']?.value),
      TX_CPF: tratarIsNullOrEmpty(this.form.controls['TX_CPF']?.value),
      TX_TELE: tratarIsNullOrEmpty(this.form.controls['TX_TELE']?.value),
      TX_PLCA_CAVA: String(
        this.form.controls['TX_PLCA_CAVA']?.value
      ).toUpperCase(),
      FK_CRRT_1: this.form.controls['FK_CRRT_1']?.value,
      FK_CRRT_2: this.form.controls['FK_CRRT_2']?.value,
      FK_CRRT_3: this.form.controls['FK_CRRT_3']?.value,
      TX_PLCA_CRRT1: tratarIsNullOrEmptyString(placaCarreta1),
      TX_PLCA_CRRT2: tratarIsNullOrEmptyString(placaCarreta2),
      TX_PLCA_CRRT3: tratarIsNullOrEmptyString(placaCarreta3),
      FK_CMNH: this.form.controls['FK_CMNH']?.value,
      TX_MAIL: tratarIsNullOrEmpty(this.form.controls['TX_MAIL']?.value),
      PermissionToken: this.permissionToken
    };
  }

  onAgendamentoChange(): void {
    const FK_AGND = this.form.controls['FK_AGND']?.value;
    if (!FK_AGND && FK_AGND.length > 0) {
      this.swalAlert.showAlert(
        'Atenção!',
        'Por favor, insira um número de agendamento válido.',
        'warning'
      );
      return;
    }
    this.openSelecaoDesengate();
  }

  onGetGateEntrada(): void {
    this.isEntradaValida = false;

    let FK_GATE_ENTR = this.form.controls['FK_GATE_ENTR'].value ?? null;

    if (!FK_GATE_ENTR) {
      this.onClearOrDisabled(true);
      return;
    }

    this.caminhaoService
      .GetLastVersionCaminhaoInfoByEntradaOrAgendamentoOrPlaca(FK_GATE_ENTR)
      .subscribe({
        next: response => {
          this.isEntradaValida = true;

          if (response.FK_GATE_SAID == null)
            this.form.patchValue({
              FK_GATE_ENTR: response.FK_GATE_ENTR ?? null,
              NM_MTRT: response.NM_USUA_MTRT || response.NM_MTRT,
              TX_MAIL: response.TX_MAIL_MTRT,
              TX_CPF: response.TX_CPF_MTRT,
              TX_TELE: response.NU_TELE_MTRT,
              TX_PLCA_CAVA: response.TX_PLCA_CAVA ?? null,
              TX_PLCA_CRRT1: response.TX_PLCA_CRRT1,
              TX_PLCA_CRRT2: response.TX_PLCA_CRRT2,
              TX_PLCA_CRRT3: response.TX_PLCA_CRRT3
            });

          this.onClearOrDisabled(false);
        },
        error: (err) => {
          this.isEntradaValida = false;
          this.swalAlert.handleError(
            err,
            'Atenção!',
            'Erro ao buscar informações da entrada.',
            'warning'
          );
        }
      });
  }

  onGetEntradaByCavalo(): void {
    this.isEntradaValida = false;

    let TX_PLCA_CAVA = this.form.controls['TX_PLCA_CAVA'].value ?? null;

    if (!TX_PLCA_CAVA) {
      this.onClearOrDisabled(true);
      return;
    }

    this.caminhaoService
      .GetLastVersionCaminhaoInfoByEntradaOrAgendamentoOrPlaca(
        null,
        null,
        TX_PLCA_CAVA
      )
      .subscribe({
        next: response => {
          this.isEntradaValida = true;

          if (response.FK_GATE_SAID == null)
            this.form.patchValue({
              FK_GATE_ENTR: response.FK_GATE_ENTR ?? null,
              NM_MTRT: response.NM_USUA_MTRT || response.NM_MTRT,
              TX_MAIL: response.TX_MAIL_MTRT,
              TX_CPF: response.TX_CPF_MTRT,
              TX_TELE: response.NU_TELE_MTRT,
              TX_PLCA_CAVA: response.TX_PLCA_CAVA ?? null,
              TX_PLCA_CRRT1: response.TX_PLCA_CRRT1,
              TX_PLCA_CRRT2: response.TX_PLCA_CRRT2,
              TX_PLCA_CRRT3: response.TX_PLCA_CRRT3
            });

          this.onClearOrDisabled(false);
        },
        error: () => {
          this.isEntradaValida = false;
          // this.swalAlert.showAlert(
          //   'Atenção!',
          //   'Erro ao buscar informações da entrada.',
          //   'warning'
          // );
        }
      });
  }

  onPlacaChange(): void {
    const TX_PLCA_DSGT = this.form.controls['TX_PLCA_DSGT']?.value;
    if (TX_PLCA_DSGT.length && TX_PLCA_DSGT < 7) {
      this.swalAlert.showAlert(
        'Atenção!',
        'Placa inválida! Por favor, insira uma placa de carreta válida.',
        'warning'
      );
      return;
    }
    this.openSelecaoDesengate();
  }

  openSelecaoDesengate(): void {
    const dialogConfig = new MatDialogConfig();
    const FK_AGND = this.form.controls['FK_AGND']?.value;
    const TX_PLCA_DSGT = this.form.controls['TX_PLCA_DSGT']?.value;

    dialogConfig.width = '680px';
    dialogConfig.disableClose = true;
    dialogConfig.data = {
      FK_AGND,
      TX_PLCA_DSGT
    };

    const dialogRef = this.dialog.open(
      ModalSelecaoDesengateComponent,
      dialogConfig
    );

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.form.controls['FK_DSGT_ENGT'].setValue(
          !validarIsNullOrEmpty(result[0].PK_ENGT_DSGT)
            ? result[0].PK_ENGT_DSGT
            : null
        );
        this.form.controls['NM_MTRT_DSGT'].setValue(
          !validarIsNullOrEmpty(result[0].NM_MTRT) ? result[0].NM_MTRT : null
        );
        this.form.controls['FK_AGND'].setValue(
          !validarIsNullOrEmpty(result[0].FK_AGND) ? result[0].FK_AGND : null
        );
        this.form.controls['FK_CMNH'].setValue(result[0].FK_CMNH);
        if (result[0] && result[0].FK_CRRT)
          this.form.controls['FK_CRRT_1'].setValue(result[0].FK_CRRT);
        if (result[1] && result[1].FK_CRRT)
          this.form.controls['FK_CRRT_2'].setValue(result[1].FK_CRRT);
        if (result[2] && result[2].FK_CRRT)
          this.form.controls['FK_CRRT_3'].setValue(result[2].FK_CRRT);
        const carretas = result.map((x: any) => x.TX_PLCA_CRRT).join(' | ');
        this.form.controls['CRRT_DSGT'].setValue(carretas);
      }
    });
  }

  onClearOrDisabled(isClear: boolean) {
    const nomeMotorista = this.form.controls['NM_MTRT'];
    const cpfMotorista = this.form.controls['TX_CPF'];
    const telefoneMotorista = this.form.controls['TX_TELE'];
    const placaCavalo = this.form.controls['TX_PLCA_CAVA'];
    const placaCarreta1 = this.form.controls['TX_PLCA_CRRT1'];
    const placaCarreta2 = this.form.controls['TX_PLCA_CRRT2'];
    const placaCarreta3 = this.form.controls['TX_PLCA_CRRT3'];

    if (isClear) {
      nomeMotorista.setValidators(Validators.required);
      placaCavalo.setValidators(Validators.required);

      nomeMotorista.setValue('');
      // cpfMotorista.setValue('');
      // placaCavalo.setValue('');
      placaCarreta1.setValue('');
      placaCarreta2.setValue('');
      placaCarreta3.setValue('');
      telefoneMotorista.setValue('');

      nomeMotorista.enable();
      // cpfMotorista.enable();
      // placaCavalo.enable();
      placaCarreta1.enable();
      placaCarreta2.enable();
      placaCarreta3.enable();
      telefoneMotorista.enable();
    } else {
      nomeMotorista.clearValidators();
      // cpfMotorista.clearValidators();
      // placaCavalo.clearValidators();
      placaCarreta1.clearValidators();
      placaCarreta2.clearValidators();
      placaCarreta3.clearValidators();
      telefoneMotorista.clearValidators();

      if (Number(this.form.controls['FK_GATE_ENTR'].value) > 0) {
        nomeMotorista.disable();
        telefoneMotorista.disable();
        // cpfMotorista.disable();
        placaCavalo.disable();
        placaCarreta1.disable();
        placaCarreta2.disable();
        placaCarreta3.disable();
      }
    }
  }

  openAcessoRestrito() {
    const dialogConfig = new MatDialogConfig();

    dialogConfig.width = '680px';
    dialogConfig.disableClose = true;
    dialogConfig.data = {
      FK_GATE_ENTR: this.form.controls['FK_GATE_ENTR'].value
    };

    const dialogRef = this.dialog.open(ModalAutorizacaoComponent, dialogConfig);

    dialogRef.afterClosed().subscribe((token: string | undefined) => {
      if (token) this.permissionToken = token;
    });
  }

  activateRoute(): void {
    this.route.queryParams.subscribe(params => {
      if (params['idEngate'] && params['isViewing'] === 'true') {
        this.isLoading = true;
        this.isViewing = true;
        this.form.disable();
        const PK_ENGT_DSGT = params['idEngate'];
        this.engateDesengateService
          .GetEngateDesengateInfoById(PK_ENGT_DSGT)
          .subscribe({
            next: res => {
              this.form.controls['FK_AGND'].setValue(
                !validarIsNullOrEmpty(res.FK_AGND) ? res.FK_AGND : null
              );
              this.form.controls['TX_PLCA_DSGT'].setValue(res.TX_PLCA_CRRT1);
              this.form.controls['NM_MTRT_DSGT'].setValue(res.NM_MTRT);
              this.form.controls['FK_GATE_ENTR'].setValue(res.FK_GATE_ENTR);
              this.form.controls['TX_OBSV_ENGT_DSGT'].setValue(
                res.TX_OBSV_ENGT_DSGT
              );
              this.form.controls['TX_MAIL'].setValue(
                res.TX_MAIL || res.TX_MAIL_MTRT
              );
              this.onGetGateEntrada();
            },
            error: err => {
              if (err?.handled) {
                this.router.navigate(['listagem/engates']);
                return;
              }
              this.swalAlert.showAlertOnConfirmNavigate(
                'Atenção!',
                'Erro ao buscar engate.',
                'warning',
                'listagem/engates'
              );
            },
            complete: () => {
              this.isLoading = false;
            }
          });
      }
    });
  }
}
